<template>
    <div class="content">
        <div class="unsupported">Internet Explorer is not a supported browser.</div>
    </div>
</template>

<script>
export default {
    name: "Unsupported",
};
</script>

<style scoped>
.content {
    text-align: center;
    margin: auto;
    width: 400px;
}

.unsupported {
    color: #fff;
    font-size: 24px;
    font-weight: bolder;
    font-weight: 300;
    margin: auto;
    padding: 40px 40px 40px 40px;
    display: block;
}
</style>

